// extracted by mini-css-extract-plugin
export default {"wrapper":"GlgYWDVFhG_keoPuDoZt","titleWrapper":"aoXZicGKa9x3nqryGX45","subTitle":"zVQEtWEpC8cMLQnTFue1"};